var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 317,
    viewBox: "0 0 231 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.825 70.55L169.17 3.66C167.13 1.334 164.187 0 161.093 0H12.9408C6.07577 0 0.509766 5.566 0.509766 12.431V304.57C0.509766 311.436 6.07577 317.001 12.9408 317.001H218.059C224.925 317.001 230.491 311.435 230.491 304.569V77.633C230.491 75.027 229.544 72.51 227.825 70.55ZM12.9408 305.073V12.432H156.94V76.033C156.94 79.464 159.72 82.249 163.156 82.249H218.059L218.065 305.073H12.9408Z",
    fill: "#00B956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.24879ddf37263cf4310d1554b91b1c9d.svg";
export { ForwardRef as ReactComponent };